import { FC, useState, useEffect } from 'react'
import { useField, FieldArray, FormikHelpers } from 'formik'
import { Trash2 } from 'react-feather'
import { CloseCircleFilled, LinkOutlined } from '@ant-design/icons'

import { Input, Button, Tooltip } from '@pepper/ui'
import { ReactComponent as TooltipInfo } from 'assets/images/mini_tooltip.svg'

import styles from './_.module.css'

interface Props {
  name: string
  label?: string
  required?: boolean
  actions: FormikHelpers<any>
  defaultStaticValue: string | number
  miniTooltip?: string
  disabled?: boolean
}

const SwitchView: FC<Props> = ({
  name,
  label,
  required,
  actions,
  miniTooltip,
  disabled = false,
}) => {
  const [field, meta, helpers] = useField(name)
  const [linkCount, setLinkCount] = useState(field.value?.length ?? 0)
  useEffect(() => {
    setLinkCount(field.value?.length ?? 0)
  }, [field.value])

  const deleteRef = (indexValue: number) => {
    const valueSet = [...field.value]
    valueSet.splice(indexValue, 1)
    helpers.setValue(valueSet)
  }

  const updateCount = () => {
    actions.setFieldTouched(name, true)
    if (!meta.error) {
      setLinkCount((oldLinkCount: number) => oldLinkCount + 1)
    }
  }
  const updateTempVal = (refData: string, data: string) => {
    actions.setFieldValue(refData, data)
  }

  return (
    <>
      <div className={styles.inputV2Wrap}>
        <label>
          <span className={styles.inputLabelV2}>
            {label}

            {required && <span className={styles.requiredText}>*</span>}
            {miniTooltip && (
              <Tooltip
                placement="top"
                title={() => (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: miniTooltip,
                    }}
                  />
                )}
              >
                <TooltipInfo className={styles.tooltipPos} />
              </Tooltip>
            )}
          </span>
          <FieldArray
            name={`${name}`}
            render={(arrayHelpers): React.ReactNode => (
              <>
                {[...Array(linkCount)].map((_, index) => (
                  <Input
                    key={index}
                    className={styles.inputAreaV2}
                    disabled={disabled}
                    onChange={e =>
                      updateTempVal(`${name}.${index}`, e.target.value)
                    }
                    placeholder={`https://example.com`}
                    value={field.value ? field.value[index] : ''}
                    suffix={
                      <Trash2
                        className={styles.delete}
                        onClick={(): void => deleteRef(index)}
                      />
                    }
                    onBlur={() => actions.setFieldTouched(name, true)}
                  />
                ))}
              </>
            )}
          />
        </label>
        <Button
          className={styles.addLink}
          onClick={updateCount}
          type="link"
          disabled={disabled}
        >
          <LinkOutlined className={styles.link} />
          Add a URL
        </Button>
        {meta.touched && meta.error ? (
          <div className={styles.error}>
            <CloseCircleFilled className={styles.errorIcon} /> {meta.error}
          </div>
        ) : null}
      </div>
    </>
  )
}

export default SwitchView
